var constants = require('../constants');

const initialState = {
    isFetching: false,
    error: {},
    data: {} // scores[0]
};

var latestScoreReducer = function(state, action) {
    state = state || initialState;

    switch (action.type) {
        case constants.LATEST_SCORE_FETCH_REQUEST:
            return Object.assign({}, state, {
                isFetching: true
            });
        case constants.LATEST_SCORE_FETCH_SUCCESS:
            return Object.assign({}, state, {
                data: action.data,
                isFetching: false
            });
        case constants.LATEST_SCORE_FETCH_FAILURE:
            return Object.assign({}, state, {
                isFetching: false,
                error: action.errors
            });
        default:
            return state;
    }
}

module.exports = latestScoreReducer;



// WEBPACK FOOTER //
// ./src/common/modules/latestScore/reducers/latestScore.js